import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=79fd7648&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=79fd7648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd7648",
  null
  
)

export default component.exports